import { motion } from "framer-motion";

// Section scroll-reveal wrapper
export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal for the hero headline
export const lineContainer = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.16, delayChildren: 0.2 },
  },
};

export const lineChild = {
  hidden: { y: "110%" },
  show: {
    y: "0%",
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  },
};

export function MaskLine({ children, className = "" }) {
  return (
    <span className="block overflow-hidden">
      <motion.span variants={lineChild} className={`block ${className}`}>
        {children}
      </motion.span>
    </span>
  );
}
